import type { AppVariant } from '@shared/types'

/**
 * Finance variant configuration. The 'Finance' literal lives here only — shared
 * pages take it as a generic prop so they stay variant-agnostic.
 */
export const FIN_FUNCTION_SCOPE = ['Finance']

/**
 * Tags every request from /finance. All Finance-only behaviour keys off this
 * rather than off functionScope, so a base-app user who ticks Finance in the
 * Function Scope step keeps core TN behaviour (WI 2072 AC 1).
 */
export const FIN_VARIANT: AppVariant = 'fin'
